import { render, staticRenderFns } from "./accountantSummaryDeliveryCapital.vue?vue&type=template&id=1072e65f"
import script from "./accountantSummaryDeliveryCapital.vue?vue&type=script&lang=js"
export * from "./accountantSummaryDeliveryCapital.vue?vue&type=script&lang=js"
import style0 from "./accountantSummaryDeliveryCapital.vue?vue&type=style&index=0&id=1072e65f&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports